export default __webpack_public_path__ + "static/hackathon-grid-3-460fdb538fdb0cae7b7a5caabae3d866.png";